import { IStaff } from "@/interfaces/Istaff";
import BusinessHoursSelector from "@/components/BusinessHoursSelector";
import { IworkingHours, IDaySchedule } from "@/interfaces/Ibusiness";

interface WorkingHoursTabProps {
  staff: IStaff;
  onSave: (workingHours: any, timezone?: string) => Promise<void>;
  isLoading?: boolean;
}

function convertToIworkingHours(workingDays: any): IworkingHours {
  // Convert IWorkingDays to IworkingHours (structure is similar, just type difference)
  const result: IworkingHours = {
    mo: null,
    tu: null,
    we: null,
    th: null,
    fr: null,
    sa: null,
    su: null,
  };
  Object.keys(result).forEach((day) => {
    if (workingDays[day]) {
      const wh = workingDays[day];
      result[day] = {
        start: wh.start,
        end: wh.end,
        shifts: wh.shifts,
      } as IDaySchedule;
    }
  });
  return result;
}

export default function WorkingHoursTab({
  staff,
  onSave,
  isLoading,
}: WorkingHoursTabProps) {
  const { profile } = staff;
  const initialWorkingHours = convertToIworkingHours(profile.working_hours);
  return (
    <div className="p-4">
      <BusinessHoursSelector
        initialWorkingHours={initialWorkingHours}
        initialTimezone={profile.timezone}
        onSave={onSave}
        isLoading={isLoading}
      />
    </div>
  );
}
